import React from 'react';
import WorkspaceItemContext from '../../app/contexts/workspace/workspace-item-context';

const useWeatherService = () => {
    const context = React.useContext(WorkspaceItemContext);
    return context.weatherService;
};

export default useWeatherService;
